import { Skeleton } from '../../Skeleton'

import * as styles from './ChatroomMessagesSkeleton.module.css'

function ChatroomMessagesSkeleton() {
  return (
    <div className={styles.chatroomMessagesSkeleton}>
      <div className={styles.item}>
        <div className={styles.header}>
          <Skeleton className={styles.avatar} />
          <Skeleton className={styles.name} />
        </div>
        <Skeleton className={styles.messageBody} />
      </div>
      <div className={styles.itemOwn}>
        <Skeleton className={styles.messageBodyOwn} />
      </div>
      <div className={styles.item}>
        <div className={styles.header}>
          <Skeleton className={styles.avatar} />
          <Skeleton className={styles.name} />
        </div>
        <Skeleton className={styles.messageBody} />
      </div>
    </div>
  )
}

export default ChatroomMessagesSkeleton
